import { SupplierDirectoryRow } from '../../../../types/advise';

// A Salesforce supplier keeps its key once picking it makes its Advise record, so a selection survives that save.
export const supplierKey = (row: SupplierDirectoryRow): string => row.sf_supplier_id ?? row.id ?? '';
